export const en: Record<string, string> = {
  "auth.signIn": "Sign In",
  "auth.confirmPassword": "Confirm Password",
  "auth.reenterPassword": "Re-enter your password",
  "auth.passwordMismatch": "Passwords do not match. Please re-enter your password.",
  "auth.emailAddress": "Email",
  "auth.password": "Password",
  "auth.forgotPassword": "Forgot password?",
  "auth.signup.createAccount": "Join KontrataPH — Free",
  "auth.signup.login": "Login",
  "auth.login.submit": "Log In",
  "auth.login.signUp": "Sign Up",
  "auth.login.welcome": "Welcome back",
  "auth.login.description": "Sign in to your KontrataPH account",
  "auth.login.passwordPlaceholder": "Your password",
  "auth.login.showPassword": "Show password",
  "auth.login.hidePassword": "Hide password",
  "auth.login.rememberMe": "Remember me",
  "auth.login.busy": "Signing in…",
  "auth.login.socialDivider": "Or sign in with",
  "auth.login.socialOptions": "Social sign-in options",
  "auth.login.continueWith": "Continue with {provider}",
  "auth.login.noAccount": "Don't have an account?",
  "auth.login.socialNotice": "{provider} sign-in is coming soon.",
  "auth.login.dismissNotice": "Dismiss notification",
  "auth.resetPassword.submit": "Update password",
  "auth.joinFree": "Join Free",
  "auth.logout": "Log Out",
  "auth.logout.busy": "Signing out…",
  "settings.description": "Manage your account.",
  "settings.accountPreferences": "Account preferences",
  "settings.preferencesSummary": "Personal details, profile and language",
  "settings.signInSecurity": "Sign in & security",
  "settings.securitySummary": "Email address and password",
  "settings.profileVisibility": "Profile visibility",
  "settings.visibilitySummary": "Manage Jobseeker discovery",
  "settings.notificationsSummary": "Email and browser push",
  "settings.dataPrivacy": "Your data & privacy",
  "settings.dataSummary": "Download your data or delete your account",
  "settings.standingSummary": "Identity, verification and warnings",
  "settings.standingLoading": "Loading account standing…",
  "settings.standingLoadFailed": "Could not load account standing. Reload to try again.",
  "settings.discoveryTitle": "Jobseeker discovery",
  "settings.discoveryDescription": "Let eligible employers find your profile",
  "settings.editPublicProfile": "Edit public profile",
  "settings.editPublicProfileDescription": "Manage your public profile details",
  "settings.emailNotificationsTitle": "Email notifications",
  "settings.emailNotificationsDescription": "Important account and marketplace events",
  "settings.browserPushTitle": "Browser push",
  "settings.deviceOnly": "For this device only",
  "settings.pushLoading": "Loading browser push availability…",
  "settings.downloadDataDescription": "Account, listings and transaction data",
  "settings.cancelScheduledDeletion": "Cancel scheduled deletion",
  "settings.keepAccount": "Keep your account and associated data",
  "settings.deletionGraceDescription": "Review the {days}-day grace period",
  "settings.noAccountIssues": "No issues on your account.",
  "settings.verification": "Verification",
  "settings.verificationDescription": "Identity and Professional verification",
  "settings.helpCenter": "Help Center",
  "settings.emailAddress": "Email address",
  "settings.confirmCurrentPassword": "Confirm your current password",
  "settings.language": "Language",
  "settings.languageDescription": "Choose your preferred language.",
  "settings.profile": "Your profile",
  "settings.profileDescription": "Update your headline, skills, experience, photo, and résumés anytime.",
  "settings.editProfile": "Edit profile",
  "settings.firstName": "First name",
  "settings.lastName": "Last name",
  "settings.legalNameNotice": "Your legal name is identity information. Changing it will be reviewed by our team (re-KYC); your verified status stays active during review.",
  "settings.saveName": "Save name",
  "settings.changeEmail": "Change email",
  "settings.current": "Current",
  "settings.newEmail": "New email",
  "settings.currentPassword": "Current password",
  "settings.sendConfirmation": "Send confirmation",
  "settings.notifications": "Notifications",
  "settings.emailEvents": "Email me about important events (verifications, payments, hires, contract updates).",
  "settings.pushUnsupported": "Browser push notifications aren't supported on this device/browser.",
  "settings.pushUnavailable": "Browser push isn't enabled on this server yet.",
  "settings.pushOn": "on",
  "settings.pushOff": "off",
  "settings.sendTest": "Send test",
  "settings.turnOff": "Turn off",
  "settings.enablePush": "Enable push",
  "settings.newPassword": "New password",
  "settings.confirmNewPassword": "Confirm new password",
  "settings.createPassword": "Create a password",
  "settings.reenterPassword": "Re-enter password",
  "settings.updatePassword": "Update password",
  "settings.passwordUpdated": "Password updated.",
  "settings.analyticsPrivacy": "Analytics privacy",
  "settings.analyticsDescription": "First-party analytics measure visits and marketplace feature use. Google Analytics 4 measures public web page views. Objecting stops both in this browser and, when signed in, records a first-party objection on your account.",
  "settings.objectAnalytics": "Object to analytics",
  "settings.yourData": "Your data",
  "settings.dataDescription": "Download a copy of everything associated with your account, or permanently delete your account.",
  "settings.downloadData": "Download my data",
  "settings.deleteAccount": "Delete my account",
  "settings.accountStanding": "Account standing",
  "settings.goodStanding": "Good standing",
  "settings.goodStandingDescription": "No issues on your account. Verify your identity to earn a Trusted badge.",
  "settings.verificationCredentials": "Verification & credentials →",
  "settings.showInJobseekers": "Show me in Jobseekers",
  "settings.discoveryOff": "Jobseeker discovery is off. Your public profile remains reachable.",
  "settings.title": "Settings",
  "settings.personalInformation": "Personal information",
  "settings.changePassword": "Change password",
};

export const tl: Record<string, string> = {
  "auth.signIn": "Mag-log In",
  "auth.confirmPassword": "Kumpirmahin ang Password",
  "auth.reenterPassword": "Ilagay muli ang password",
  "auth.passwordMismatch": "Hindi magkapareho ang mga password. Pakilagay muli ang iyong password.",
  "auth.emailAddress": "Email Address",
  "auth.password": "Password",
  "auth.forgotPassword": "Nakalimutan ang Password?",
  "auth.signup.createAccount": "Gumawa ng Account",
  "auth.signup.login": "Mag-log In",
  "auth.login.submit": "Mag-log In",
  "auth.login.signUp": "Mag-sign Up",
  "auth.login.welcome": "Maligayang pagbabalik",
  "auth.login.description": "Mag-log in sa iyong KontrataPH account",
  "auth.login.passwordPlaceholder": "Iyong password",
  "auth.login.showPassword": "Ipakita ang password",
  "auth.login.hidePassword": "Itago ang password",
  "auth.login.rememberMe": "Tandaan ako",
  "auth.login.busy": "Nagla-log in…",
  "auth.login.socialDivider": "O mag-log in gamit ang",
  "auth.login.socialOptions": "Mga opsyon sa social login",
  "auth.login.continueWith": "Magpatuloy gamit ang {provider}",
  "auth.login.noAccount": "Wala ka pang account?",
  "auth.login.socialNotice": "Malapit nang maging available ang pag-log in gamit ang {provider}.",
  "auth.login.dismissNotice": "Isara ang abiso",
  "auth.resetPassword.submit": "Palitan ang Password",
  "auth.joinFree": "Sumali nang Libre",
  "auth.logout": "Mag-log Out",
  "auth.logout.busy": "Nagla-log out…",
  "settings.description": "Pamahalaan ang iyong account.",
  "settings.accountPreferences": "Mga kagustuhan sa account",
  "settings.preferencesSummary": "Personal na detalye, profile at wika",
  "settings.signInSecurity": "Pag-sign in at seguridad",
  "settings.securitySummary": "Email address at password",
  "settings.profileVisibility": "Pagpapakita ng profile",
  "settings.visibilitySummary": "Pamahalaan ang Jobseeker discovery",
  "settings.notificationsSummary": "Email at browser push",
  "settings.dataPrivacy": "Iyong datos at privacy",
  "settings.dataSummary": "I-download ang datos o burahin ang account",
  "settings.standingSummary": "Pagkakakilanlan, beripikasyon at mga babala",
  "settings.standingLoading": "Nilo-load ang katayuan ng account…",
  "settings.standingLoadFailed": "Hindi ma-load ang katayuan ng account. I-reload para subukan muli.",
  "settings.discoveryTitle": "Jobseeker discovery",
  "settings.discoveryDescription": "Hayaang makita ng mga kwalipikadong employer ang profile mo",
  "settings.editPublicProfile": "I-edit ang pampublikong profile",
  "settings.editPublicProfileDescription": "Pamahalaan ang detalye ng pampublikong profile mo",
  "settings.emailNotificationsTitle": "Mga abiso sa email",
  "settings.emailNotificationsDescription": "Mahahalagang kaganapan sa account at marketplace",
  "settings.browserPushTitle": "Browser push",
  "settings.deviceOnly": "Para lamang sa device na ito",
  "settings.pushLoading": "Nilo-load ang availability ng browser push…",
  "settings.downloadDataDescription": "Datos ng account, mga listing at transaksyon",
  "settings.cancelScheduledDeletion": "Kanselahin ang nakatakdang pagbura",
  "settings.keepAccount": "Panatilihin ang account at kaugnay na datos",
  "settings.deletionGraceDescription": "Suriin ang {days} araw na palugit",
  "settings.noAccountIssues": "Walang isyu sa account mo.",
  "settings.verification": "Beripikasyon",
  "settings.verificationDescription": "Beripikasyon ng pagkakakilanlan at propesyon",
  "settings.helpCenter": "Sentro ng tulong",
  "settings.emailAddress": "Email address",
  "settings.confirmCurrentPassword": "Kumpirmahin ang kasalukuyang password",
  "settings.language": "Wika",
  "settings.languageDescription": "Piliin ang gusto mong wika.",
  "settings.profile": "Iyong profile",
  "settings.profileDescription": "I-update anumang oras ang headline, mga kasanayan, karanasan, larawan, at résumé mo.",
  "settings.editProfile": "I-edit ang profile",
  "settings.firstName": "Pangalan",
  "settings.lastName": "Apelyido",
  "settings.legalNameNotice": "Impormasyon ng pagkakakilanlan ang legal mong pangalan. Susuriin ng aming team ang pagbabago (re-KYC); mananatiling aktibo ang beripikasyon mo habang sinusuri ito.",
  "settings.saveName": "I-save ang pangalan",
  "settings.changeEmail": "Palitan ang email",
  "settings.current": "Kasalukuyan",
  "settings.newEmail": "Bagong email",
  "settings.currentPassword": "Kasalukuyang password",
  "settings.sendConfirmation": "Ipadala ang kumpirmasyon",
  "settings.notifications": "Mga Abiso",
  "settings.emailEvents": "Padalhan ako ng email tungkol sa mahahalagang kaganapan (beripikasyon, bayad, pagkuha, at update sa kontrata).",
  "settings.pushUnsupported": "Hindi sinusuportahan ng device o browser na ito ang mga browser push notification.",
  "settings.pushUnavailable": "Hindi pa naka-enable ang browser push sa server na ito.",
  "settings.pushOn": "naka-on",
  "settings.pushOff": "naka-off",
  "settings.sendTest": "Magpadala ng test",
  "settings.turnOff": "I-off",
  "settings.enablePush": "I-enable ang push",
  "settings.newPassword": "Bagong password",
  "settings.confirmNewPassword": "Kumpirmahin ang bagong password",
  "settings.createPassword": "Gumawa ng password",
  "settings.reenterPassword": "Ilagay muli ang password",
  "settings.updatePassword": "I-update ang password",
  "settings.passwordUpdated": "Na-update na ang password.",
  "settings.analyticsPrivacy": "Privacy ng Analytics",
  "settings.analyticsDescription": "Sinusukat ng first-party analytics ang mga pagbisita at paggamit ng marketplace. Sinusukat ng Google Analytics 4 ang mga page view sa pampublikong website. Ihihinto ng pagtutol ang pareho sa browser na ito at, kapag naka-sign in, itatala rin ang pagtutol sa iyong account.",
  "settings.objectAnalytics": "Tutulan ang analytics",
  "settings.yourData": "Iyong data",
  "settings.dataDescription": "Mag-download ng kopya ng lahat ng kaugnay sa account mo o permanenteng burahin ang account.",
  "settings.downloadData": "I-download ang data ko",
  "settings.deleteAccount": "Burahin ang account ko",
  "settings.accountStanding": "Katayuan ng account",
  "settings.goodStanding": "Maayos ang katayuan",
  "settings.goodStandingDescription": "Walang isyu sa account mo. Beripikahin ang pagkakakilanlan para makakuha ng Trusted badge.",
  "settings.verificationCredentials": "Beripikasyon at mga kredensyal →",
  "settings.showInJobseekers": "Ipakita ako sa mga Naghahanap ng Trabaho",
  "settings.discoveryOff": "Naka-off ang pagtuklas ng naghahanap ng trabaho. Maaabot pa rin ang pampublikong profile mo.",
  "settings.title": "Mga Setting",
  "settings.personalInformation": "Personal na Impormasyon",
  "settings.changePassword": "Palitan ang Password",
};
